import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "ui-radio-button-input",
  styleUrls: ["./ui-styles.css"],
  template: `<mat-radio-group
    color="primary"
    aria-labelledby="example-radio-group-label"
    class="btn-radio-group"
    [(ngModel)]="currentQuestion.answerText"
    *ngIf="currentQuestion?.dataTypeName == 'button'"
    style="width: 250px; margin-left: auto; margin-right: auto;"
  >
    <mat-radio-button
      class="example-radio-button"
      style="width:50%"
      *ngFor="let option of currentQuestion.options"
      [value]="option.value"
    >
      <span
        style="white-space: normal;"
        class="btn"
        [ngStyle]="{ width: option.text === 'Yes' ? '100px' : '100px' }"
        [ngClass]="
          option.value === currentQuestion.answerText
            ? 'btn-novant-primary'
            : 'btn-novant-outline'
        "
      >
        {{ option.text }}</span
      >
    </mat-radio-button>
  </mat-radio-group>`,
})
export class RadioButtonInputComponent implements OnInit {
  @Input() currentQuestion: any;

  constructor() {}

  ngOnInit() {}
}
